import { Link } from 'react-router-dom';
import logo from '@assets/images/logos/logo.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faYoutube, faTiktok, faDiscord } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-gray-900 dark:bg-brand-dark-900 border-t border-gray-800 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main footer content */}
        <div className="py-8 flex flex-col sm:flex-row justify-between items-center gap-6">
          {/* Left section - Logo and links */}
          <div className="flex flex-col sm:flex-row items-center gap-6">
            <Link to="/" className="flex items-center">
              <img src={logo} alt="LineLeaders" className="h-8" />
            </Link>
            <div className="flex items-center space-x-6">
              <Link 
                to="/tos" 
                className="text-sm text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
              >
                Terms of Service
              </Link>
              <Link 
                to="/privacy" 
                className="text-sm text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
              >
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Right section - Social links */}
          <div className="flex items-center space-x-6">
            <a 
              href="https://twitter.com/LineLeadersLLC" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faTwitter} size="lg" />
              <span className="sr-only">Twitter</span>
            </a>
            <a 
              href="https://www.youtube.com/@LineLeaders" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faYoutube} size="lg" />
              <span className="sr-only">YouTube</span>
            </a>
            <a 
              href="https://www.tiktok.com/@lineleadersllc" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faTiktok} size="lg" />
              <span className="sr-only">TikTok</span>
            </a>
            <a 
              href="https://discord.gg/x6NFz8hFun" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-brand-red-500 dark:text-gray-400 dark:hover:text-brand-red-500 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faDiscord} size="lg" />
              <span className="sr-only">Discord</span>
            </a>
          </div>
        </div>

        {/* Copyright section */}
        <div className="py-4 border-t border-gray-800 dark:border-gray-800">
          <p className="text-center text-sm text-gray-400 dark:text-gray-500">
            © 2023-{currentYear} LineLeaders™. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;